module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dLMfr"))).then(() => parcelRequire('1iHdE'));